import styled from 'styled-components';

export const ActionButtonsWrapper = styled.div`
  display: flex;
  gap: 24px;
  padding-bottom: 16px;
`;
